import React from 'react'

const Tiktok = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M7.74402 24.3829C1.96869 22.5989 -0.990021 17.1014 0.298297 10.6946C1.38453 5.29814 5.68208 0.950071 10.7027 0.163818C16.1876 -0.691903 21.6061 1.85947 24.249 6.5391C28.6034 14.2532 24.0059 23.4704 15.1771 24.7997C12.692 25.1723 10.2638 25.0524 7.74402 24.3829Z"
            fill="#666059"
        />
        <path
            d="M16.654 7.13144C16.1907 6.60233 15.9018 5.94721 15.8206 5.25494C15.7946 5.03319 15.616 4.85156 15.3928 4.85156H13.7031C13.4799 4.85156 13.2989 5.03254 13.2989 5.2558V14.8766C13.28 15.4192 13.0511 15.9333 12.6604 16.3104C12.2698 16.6875 11.7479 16.8981 11.205 16.8977C10.0569 16.8977 9.10293 15.9599 9.10293 14.7957C9.10293 13.5875 10.1161 12.6418 11.2886 12.6955C11.5606 12.708 11.8275 12.5146 11.8275 12.2422V10.5899C11.8275 10.3873 11.6771 10.214 11.4748 10.2022C8.83566 10.0488 6.59668 12.148 6.59668 14.7957C6.59668 17.4879 8.82805 19.404 11.1969 19.404C13.7355 19.404 15.7971 17.3424 15.7971 14.7957V10.4984C15.7971 10.1692 16.1752 9.97138 16.4657 10.1264C17.2081 10.5226 18.0277 10.7573 18.8702 10.8131C19.0927 10.8279 19.2735 10.6456 19.2735 10.4226V8.75203C19.2735 8.52119 19.0802 8.33186 18.8513 8.30153C18.3216 8.23131 17.3929 7.98439 16.654 7.13144Z"
            fill="white"
        />
    </svg>
)

export default Tiktok
